import { Route } from "@/enums/route";
import { getRouteSegments, isRouteActive } from "@/utils/routeSegments";

export interface BreadcrumbTrail {
  /** First route segment, used as the `nav.*` label key; "" on the dashboard. */
  section: string;
  /** Set on `/recipient/new/**`: the New crumb, plus the segment after it. */
  newRecipient?: { step: string | undefined };
  /** The second crumb's text, when the page shows one. */
  subsection?: string;
}

/**
 * What the header breadcrumb shows for a pathname, matched on whole segments.
 * Exchange ids and recipient details ids are never shown; pay shows its
 * product type.
 */
export function getBreadcrumbTrail(pathname: string): BreadcrumbTrail {
  const [section = "", subsection, thirdSegment] = getRouteSegments(pathname);

  if (isRouteActive(pathname, Route.NewRecipient)) {
    return { section, newRecipient: { step: thirdSegment } };
  }

  const hidesSubsection =
    isRouteActive(pathname, Route.Exchange) ||
    isRouteActive(pathname, Route.Recipient);

  if (!subsection || hidesSubsection) {
    return { section };
  }

  return {
    section,
    subsection: isRouteActive(pathname, Route.Pay)
      ? subsection.charAt(0).toUpperCase() + subsection.slice(1)
      : subsection,
  };
}
